// File: app.module.ts
// Author: Joseph M Diaz
// Date: 4/20/2017
// Desc: Root module for the app.
// Other Contributors: Brandon Shreve

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Validators, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AppService } from './app.service';
import { LoggedOutComponent } from './logged-out/logged-out.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { UserProfileComponent } from './user-profile/user-profile.component';

import { CgpModule } from './cgp.module';
import { SharedModule } from './shared/shared.module';
import { MescModule } from './components/mesc/mesc.module';
import { CamtlModule } from './components/camtl/camtl.module';
import { TntModule } from './components/tnt/tnt.module';
import { BreadcrumbsComponent } from './shared/breadcrumbs/breadcrumbs.component';
import { AuthenticationService } from './auth.service';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        MatToolbarModule,
        MatSidenavModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        SharedModule,
        MescModule,
        CamtlModule,
        TntModule,
        ReactiveFormsModule,
    ],
    declarations: [
        AppComponent,
        HomeComponent,
        LoggedOutComponent,
        NotFoundComponent,
        UnauthorizedComponent,
        BreadcrumbsComponent,
        UserProfileComponent,
    ],
    providers: [
        AppService,
        AuthenticationService
    ],
    exports: [
        UserProfileComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
